import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import store from "./store";
import Main from "./components/Layout/Main";
import Home from "./components/Home";
import Register from "./components/Auth/Register";
import Login from "./components/Auth/Login";
import Profile from "./components/Profile/Profile";
import NotFound from "./components/NotFound";
import Search from "./components/Search/NotFound";
import setAuthHeader from "./utils/setAuthHeader";
import { logoutUser, getCurrentUser } from "./actions/authActions";
import { themeDark, themeLight } from './themes';
import ThemeProviderComponent from "./ThemeProviderComponent";

const AppContent = () => {
  const darkMode = useSelector((state) => state.darkMode.darkMode);

  return (
    <ThemeProviderComponent theme={darkMode ? themeDark : themeLight}>
      <BrowserRouter>
        <Main>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/login" component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/profile/:userId" component={Profile} />
            <Route path="/search" component={Search} />
            <Route component={NotFound} />
          </Switch>
        </Main>
      </BrowserRouter>
    </ThemeProviderComponent>
  );
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("jwtToken") !== null
  );

  useEffect(() => {
    if (isAuthenticated) {
      const currentTime = Date.now() / 1000;
      const decode = jwt_decode(localStorage.getItem("jwtToken"));

      if (currentTime > decode.exp) {
        setIsAuthenticated(false);
        store.dispatch(logoutUser());
        window.location.href = "/";
      } else {
        setAuthHeader(localStorage.getItem("jwtToken"));
        store.dispatch(getCurrentUser());
      }
    }
  }, [isAuthenticated]);

  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
};

export default App;
